



































































import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import {
  CloseNodeDto,
  CloseVChannelDto,
  ConnectionServiceProxy
} from "@/service-proxies/app-v2/iot-extranetv2-serve.service-proxies";

@Component({
  components: {

  },
})
export default class ConnectionList extends Vue {

  conServProxy = new ConnectionServiceProxy();


  columns = [
    {
      title: '操作',
      key: 'action',
      scopedSlots: {
        customRender: 'action'
      },
    },
    {
      title: '连接码',
      dataIndex: 'connectCode',
      key: 'connectCode',
    },
    {
      title: '连接时间',
      dataIndex: 'connectTime',
      key: 'connectTime',
      scopedSlots: {
        customRender: 'connectTime'
      },
    },
    {
      title: '网关',
      dataIndex: 'gatewayId',
      key: 'gatewayId',
      scopedSlots: {
        customRender: 'gateway',
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
      },
      onFilter: (value, record) =>
          record.gatewayId
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
    },
    {
      title: 'PC',
      dataIndex: 'pcId',
      key: 'pcId',
      scopedSlots: {
        customRender: 'pc',
        filterDropdown: 'filterDropdown',
        filterIcon: 'filterIcon',
      },
      onFilter: (value, record) =>
          record.pcId
              .toString()
              .toLowerCase()
              .includes(value.toLowerCase()),
    },
    {
      title: '参数',
      dataIndex: 'linkParamInfo',
      key: 'linkParamInfo',
    },

  ];

  data = [];
  keyWorld = ''


  searchInput=null;
  searchText='';
  searchedColumn=null;

  handleSearch(selectedKeys, confirm, dataIndex) {
    confirm();
    this.searchText = selectedKeys[0];
    this.searchedColumn = '';
  }

  handleReset(clearFilters) {
    clearFilters();
    this.searchText = '';
  }


  mounted(){
    this.refreshList();
  }

  refreshList(){
    this.keyWorld = ''
    this.conServProxy.findVChannelList()
        .then(res=>{
          this.data = res.data;
        })
  }

  confirmClose(connectCode){
    //
    const dto = new CloseVChannelDto();
    dto.connectCode= connectCode;
    this.conServProxy.closeVChannel(dto)
        .then(res=>{
          this.refreshList();
        })
  }

  search(){
    this.conServProxy.findVChannelList()
        .then(res => {
          let newData = res.data;
          this.data = newData
          if (this.keyWorld){
            let kw = this.keyWorld.trim()
            this.data = newData.filter( (item) =>
                item.gatewayId.indexOf(kw.toUpperCase()) != -1 ||
                item.pcId.indexOf(kw.toUpperCase()) != -1 ||
                item.pcIp.indexOf(kw) != -1 ||
                item.gatewayIp.indexOf(kw) != -1 ||
                item.connectCode.indexOf(kw) != -1 ||
                item.linkParamInfo.indexOf(kw) != -1
            )
          }
        })
  }

}
